export function getPrice(plan) {
  if (plan.price > 0) {
    return plan.price;
  }

  const price = plan.services.reduce((total, service) => {
    return total + service.price;
  }, 0);

  return price - (price * plan.discount) / 100;
}

export function getRegularPrice(plan) {
  return plan.services.reduce((total, service) => {
    return total + service.price;
  }, 0);
}

export function getPriceWithOnlineDiscount(plan) {
  const price = getPrice(plan);

  return plan.online_pay_discount > 0 ? price - (price * plan.online_pay_discount) / 100 : price;
}

export function isEligible(services = [], maintenancePlan) {
  const planServices = maintenancePlan.services.sort((a, b) => {
    if (a.name === b.name) {
      return 0;
    }
    return a.name > b.name ? 1 : -1;
  });
  const firstService = planServices[0];

  return services.reduce((eligible, service) => {
    return eligible || service.id === firstService.id;
  }, false);
}
